import { Consumer } from '../context'

export default Consumer



// WEBPACK FOOTER //
// ./src/auth/components/AuthConsumer.jsx